import { useSelector } from 'react-redux';
import { TStore } from '../basis/types/tstore';

// 获取当前用户登录状态
export const usePersonLogin = () => {
  const token = useSelector((state: TStore.State) => state.person.user?.token);
  const isLogined = !!token;

  return { isLogined };
};
